module.exports = __webpack_public_path__ + "static/img/egg_g_20.054f042.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/defult/img/eggs/g/egg_g_20.png
// module id = Luvo
// module chunks = 1